import { Card } from '@cortex/web-design-system/components/ui/Card';

interface RevenueMetricCardProps {
  label: string;
  value: string;
  sub?: string;
}

/**
 * @graph-node {Module}
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business 売上集計ページで使う共通KPIカード（ラベル・値・補足）。サマリ/前受金/検算の各タブから共有される。
 * @graph-connects none
 */
export function RevenueMetricCard({ label, value, sub }: RevenueMetricCardProps) {
  return (
    <Card className="flex flex-col gap-1 p-4">
      <span className="text-xs font-medium tracking-wider text-[var(--color-text-muted)] uppercase">
        {label}
      </span>
      <span className="text-2xl font-bold text-[var(--color-text-primary)]">{value}</span>
      {sub && <span className="text-xs text-[var(--color-text-secondary)]">{sub}</span>}
    </Card>
  );
}
